export default "/corgi/pageapps/purchase/_next/static/media/gift.76b3fb4e.svg";